The name of the advertisement product for displaying to the user.

This field is for display purposes only and should not be used to determine any features of an ad.
